import React from 'react';
import { Trans } from 'react-i18next';
import MobileButton from './Button';
import { helpButtons } from './data/ButtonsData';

export default function ModalHelp({ icon = {}, number = '', email = '' }) {
	return (
		<>
			<div className="content">
				{icon}
				<Trans i18nKey="title_help">
					<h5>
						<i>NEED HELP?</i>
					</h5>
				</Trans>

				<Trans i18nKey="modal_needhelp">
					<div className="modalhelp_btn_container">
						{helpButtons.map(m => (
							<MobileButton
								key={m.text}
								text={m.text}
								onClick={() => window.open(m.btn_link, 'blank')}
								className={m.class}
							/>
						))}
					</div>
				</Trans>
				<div className="contact">
					{/* mobile number not needed for now */}
					{/* <div className="mobile"> 
						<img
							alt="mobile number"
							src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAABg0lEQVRYw2NgGKRAE4iLgXghEIfR02JTID4IxP/R8FYgFqa15YlA/BuL5TB8HYglaWW5GQHLYfgkELPSwgHziLAchgtp4YBiEhxwH4gZqe0AWSD+S4IjlGgRCnuJtPwnECvQwgGRRDognlY5gQ2InxOwfAqty4JaPJbfBmJOWjtACIg/4nBALL2K4yYcDkiglwP4gPgVFgfcAmJ2ejkiFUcotNHLAUxAfBSLA0CFlQe9HKEBxN+wOOIDEOvRyxGZOKLiBRDr0MsRS3E44i0Q2+PRB6qwyoB4EbRVRXYC5oK2A7A54hfUEiY0PSJAvAlN7TMgTia3JhUD4pt4SsnjQGwCxMzQuuIlHrXroZ4iGchAywJcBv/DUX5gwzuBmIUcR0gA8TkS2g34cBm5aYIHiNdRwQFzKMkZoIRUBMQ/KHBAMjWyqDYQHyPDclCrSpRa5QQjtKq+T4IDZtKqRZUExJcIWP4EWk7QFFgC8VQsTTxQ+WBAz74mE7S/WQt1kMyg64YDADenHn6oi/aiAAAAAElFTkSuQmCC"
							style={{ width: '27px', height: '27px' }}
						/>
						<p>{number}</p>
					</div> */}
					<div className="email">
						<img
							alt="email"
							src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsSAAALEgHS3X78AAADLUlEQVRYw+1Xv28TMRROIlWoUS8SYmilwr2LncDOilBnBtjoSBfGSkzwF8CGAjMLsDHCwsw/AIIJiW4MtBKKFCRgSO4H37Offb5LFJEmUZee9Mk++/l7P+3zNRrnz1k/mpKGjsn3FfqKCGOJbXl+CTgOz4s+P/xu+l45FO5uX1m/xxd3jXJnhCgnP4/BC7B0CwZFaCNuYenpEFMEPsOBdou5Sz1JJQUticJdCP2G4r/oD9H/hXnAtYvArmEOReACJ/AHY/viaKuSAjGgDTxkwX5XFRBYCQxXbJQ/AtpBtKVDHO7kEFY3bVRIY8HbXtI1BDBoDGQIW473HLKmnQWQomVZGvNa5kD/Hfi0pLsFJw85RWHeO9Za+gyBG0GeDiB83E/YgyTDXCpe5WKM9TL2RrGyFHMZr8HYMTgPygjTTeCL6OqEW5ELbtgXj4GnEGhLWnaw6FWPugUDc2PrpTVEwIRsxNjIWZ7XwI5wcFEPTDrs3LAegUiKp2DPbP7pK3ArsP4OcCRzOQhdNNjT1K0D1xHLButuA9/snIsSdEFnEAHeLtYAmz94Uub/BYQvOUOBZy63aCeQn/R85Oi5EmIYuI11L3tlHYzxnknKeJdElRS4CGhnJZW5xMLvWLAf7JY94COHk4EIfMKavcDre5j/IXWQuWgpny6ja64Blbz6aiZ6g7HLbh8Dj6HsCWSaYphWtd2jfb1QwDvPgEC5Liudo5FKAf0E8f36CQvFD5hDIpKaXVN6nVe5/8uAGVUec84l/zG9x9g1KL6O/ge3g/A+0eEuiaf4FjKgmN73ppBSG2biLZlJyFNXZDWvi1UYMBUNLdGwdUOpnnk2rNaAYnqe8vBQCvrFYgbECxmwDFwEa+eA+WbTKNguazUANTJSlaOYko5yR/H8HC4B85XMpWb4KO7U7wEnrqAklyuFfKbl+0HQRZuuAFtykAyuKl2sMfwGrAMH2UAcbzWCS8gGwj9ABE7kKjYqr2SnR8ilrOcD9DdEZ7NR6diC3JQLSiSf6aXgOJhTyR2jrtwPKLmcrvU/xFxGfdSDH4TgJ8WNuXapH5O4+mOiSofLq/n5c5bPP2le744WXWFJAAAAAElFTkSuQmCC"
							style={{ width: '29px', height: '29px' }}
						/>

						<p>
							<a href={`mailto:${email}`} style={{ color: '#000' }}>
								{email}
							</a>
						</p>
					</div>
				</div>
			</div>
		</>
	);
}
